import { Component, Inject, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';
import { StudentVoiceHelperService } from '../../_helpers/student-voice-helper/student-voice-helper.service';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { ThankYouBannerComponent } from '../../shared/thank-you-banner/thank-you-banner.component';
import { StudentFeedbackService } from '../../_services/student-feedback/student-feedback.service';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class DialogData {
  studentId: number;
  placementId: number;
  placementStartDate: Date;
  placementEndDate: Date;
  modalHeader: string;
  feedbackSurvey: FeedbackSurvey;
  isManualEntry: boolean;
  showHeaderText: boolean;
}

@Component({
    selector: 'feedback-modal',
    templateUrl: './feedback-modal.component.html',
    styleUrls: ['./feedback-modal.component.css'],
    standalone: false
})
export class FeedbackModalComponent implements OnInit, OnChanges {
  @ViewChild(ThankYouBannerComponent, {static: true}) private thankYouBanner!: ThankYouBannerComponent;

  public disableModalDone: boolean = true;
  public submitted: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public themeService: ThemeService,
    public studentVoiceHelper: StudentVoiceHelperService,
    private feedbackService: StudentFeedbackService,
    private errorModalHelper: ErrorModalHelperService,
    private dialogRef: MatDialogRef<FeedbackModalComponent>
    ) { }

  ngOnInit() {
    this.checkSurveyPopulated();
  }

  ngOnChanges(): void {
    this.checkSurveyPopulated();
  }

  public feedbackSubmitted(submitted): void {
    if (submitted) {
      this.submitted = true;
      setTimeout(() => {
        this.thankYouBanner.generateBanner();
      }, 100);
    } else {
      if (this.thankYouBanner) {
        this.thankYouBanner.removeBanner();
      }
      this.submitted = false;
    }
  }
  
  public checkSurveyPopulated() : void {
    if (!this.data.feedbackSurvey) {
      
      this.feedbackService.requestTuitionFeedbackSurvey(this.data.studentId, this.data.placementId, this.data.placementStartDate, this.data.placementEndDate).subscribe((feedbackSurvey: FeedbackSurvey) => {

        this.data.feedbackSurvey = feedbackSurvey;
        
        
      }, error => {
        this.errorModalHelper.show(error.message, error);
        this.dialogRef.close();
        console.error(error);
      });
    }
  }


}
